/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  GetSubscriptionDetails,
  SubScriptionState
} from 'services/api/subscriptionApi';

export const fetchAllSubscription = createAsyncThunk(
  'spaces/fetchAllSubscription',
  async (payload, thunkAPI) => {
    try {
      const response = await GetSubscriptionDetails();
      return response?.data?.data?.subscriptions; // Adjusted to match the new API response structure
    } catch {
      return thunkAPI.rejectWithValue('failed');
    }
  }
);

const initialSubscriptionState: SubScriptionState = {
  subscriptionData: [],
  isLoading: false,
  selectedSubscriptionInfo: null
};

export const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState: initialSubscriptionState,
  reducers: {
    clearSubscriptionData: (state) => {
      state.subscriptionData = [];
      state.selectedSubscriptionInfo = null;
    },
    setSelectedSubscriptionInfo: (state, action) => {
      state.selectedSubscriptionInfo = action.payload;
    },
    clearSelectedSubscriptionInfo: (state) => {
      state.selectedSubscriptionInfo = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllSubscription.fulfilled, (state, action) => {
        state.isLoading = false;
        state.subscriptionData = action.payload;
      })
      .addCase(fetchAllSubscription.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchAllSubscription.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

// Action creators are generated for each case reducer function
export const {
  clearSelectedSubscriptionInfo,
  setSelectedSubscriptionInfo,
  clearSubscriptionData
} = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
